(function () {
	'use strict';

	angular
		.module('wizard-future7', [
			'ngSanitize',
			'ui.router',
			'ngMask',
			'angularValidator',
			'19degrees.ngSweetAlert2',
			'ui.select',
			'timer',
			'ui.utils.masks',
			'ui.swiper',

			'wizard-future7.configs',
			'wizard-future7.constants',
			'wizard-future7.directives',
			'wizard-future7.routes',
			'wizard-future7.services',
		])
		.run(run);

	/** @ngInject */
	function run(HelperService, $trace, $transitions, $rootScope, $state, $window) {
		$trace.enable(1, 5);

		HelperService.handleOnRun();

		$transitions.onEnter({}, $transition => {
			return HelperService.handleStateChangeStart($transition);

		});

		$transitions.onSuccess({}, $transition => {
			$rootScope.pageTitle = `${$transition.to().title} | Wizard Idiomas`;
			$rootScope.currentState = $state.current.name;
		});

		$transitions.onSuccess({}, $transition => {
			$rootScope.pageTitle = `${$transition.to().title} | Wizard Idiomas`;
			$rootScope.currentState = $state.current.name;

			HelperService.handleStateChangeSuccess($transition);
		});

		$transitions.onError({}, ($transition, error) => {
			HelperService.handleStateChangeError(error);
		});

		$window.onload = () => {
			HelperService.handleViewContentLoaded();

		}

		$rootScope.$on('$viewContentLoaded', HelperService.handleViewContentLoaded);

	}
})();